import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import Swal from 'sweetalert2';
import IdCardServiceConfigPanel from 'Components/IdCardServiceConfigPanel';
import {
  createEmptyIdCardConfig,
  normalizeIdCardConfig,
  validateIdCardConfig,
} from 'Containers/Billing/idCardServiceConfig';

function IdCardServiceConfigModal({ open, onClose, onConfirm, initialConfig }) {
  const [config, setConfig] = React.useState(createEmptyIdCardConfig());

  React.useEffect(() => {
    if (open) {
      setConfig(normalizeIdCardConfig(initialConfig || createEmptyIdCardConfig()));
    }
  }, [open, initialConfig]);

  const handleConfirm = () => {
    const { valid, errors } = validateIdCardConfig(config);
    if (!valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete configuration',
        html: errors.map((e) => `<div>${e}</div>`).join(''),
      });
      return;
    }
    onConfirm(normalizeIdCardConfig(config));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Configure ID Cards</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Choose Staff and/or Student ID card types, then select items and enter quantity with per unit price.
        </Typography>
        <IdCardServiceConfigPanel config={config} onChange={setConfig} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button variant="contained" onClick={handleConfirm}>Add ID card service</Button>
      </DialogActions>
    </Dialog>
  );
}

export default IdCardServiceConfigModal;
